import type React from 'react';

import { Helmet } from 'react-helmet-async';

import { usePageMeta } from './hooks/usePageMeta';

export const PageMeta: React.FC = () => {
	const {
		data: { title },
	} = usePageMeta();

	return (
		<Helmet>
			<title>{title}</title>
		</Helmet>
	);
};
